import LiveReportOpen2 from "./LiveReportOpen2";

const LiveReportOpen = () => {
    return <LiveReportOpen2 />;
}

export default LiveReportOpen
